<div class="filter-container">
    <mat-form-field appearance="outline" class="search-field">
      <input
        matInput
        name="Search"
        ngDefaultControl
        placeholder="Search for names of assets and their description"
        (keyup)="modelChange.emit(model)"
        [(ngModel)]="model"
        (keyup.enter)="onFetchCompanies()"
      >
    </mat-form-field>
    <div class="result-count">
        {{meta && meta.total ? meta.total : 0}} results
    </div>
    <button type="button" mat-flat-button color="primary" (click)="onFetchCompanies()">
        <mat-icon class="navigation-button">search</mat-icon>
        <span class="navigation-button">Search</span>
    </button>
</div>
